import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { SuspenseLoading } from "@/shared/ui";

export default function Auth0Callback() {
  const { isLoading, isAuthenticated, error } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      if (isAuthenticated) {
        // Redirect to admin dashboard after successful authentication
        navigate("/admin");
      } else if (error) {
        // Redirect to home on error
        navigate("/");
      }
    }
  }, [isLoading, isAuthenticated, error, navigate]);

  if (isLoading) {
    return <SuspenseLoading />;
  }

  return <SuspenseLoading />;
}
